export default "__VITE_ASSET__O6UGBYXK57I7akFyyO$NyQ__"